module.exports = __webpack_public_path__ + "static/media/banner-thuong-mai.45d49877.jpg";